












































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'

@Component
export default class Alert extends Vue {
  public toast (message: any) {
    this.$root.$bvToast.toast(message.text, {
      id: 'toast',
      title: this.judgeTitle(message.type),
      autoHideDelay: 5000,
      noAutoHide: this.judgeAutoHide(message.type),
      toaster: 'b-toaster-top-right',
      headerClass: this.judgeClassName(message.type),
      static: true
    })
  }

  private judgeTitle (key: number) {
    switch (key) {
      case 0:
        return 'Success'

      case 1:
        return 'Error'

      case 2:
        return 'Warning'

      default:
        break
    }
  }

  private judgeClassName (key: number) {
    switch (key) {
      case 0:
        return 'success'

      case 1:
        return 'error'

      case 2:
        return 'warning'

      default:
        break
    }
  }

  private judgeAutoHide (key: number) {
    switch (key) {
      case 0:
        return false

      case 1:
        return true

      case 2:
        return true

      default:
        break
    }
  }
}
